function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import PictureComponent from "components/core/picture/picture-component";
import { StyledButtonImageTag } from "./button-image-tag.scss";
import DefaultProps from "./default-props";
const imageHeight = "64px";
class ButtonImageTag extends PureComponent {
    render() {
        const { tagImg, tagText, link } = this.props;
        return /*#__PURE__*/ _jsx(StyledButtonImageTag, {
            className: "button-image-tag",
            children: /*#__PURE__*/ _jsxs("a", _object_spread_props(_object_spread({
                className: classnames("button-image-tag-anchor", {
                    clickable: link
                })
            }, this.getInputProps()), {
                children: [
                    /*#__PURE__*/ _jsx(PictureComponent, _object_spread_props(_object_spread({}, tagImg), {
                        specificImageStyle: {
                            height: imageHeight
                        },
                        pictureClass: "button-tag-image",
                        isDecorative: true
                    })),
                    /*#__PURE__*/ _jsx("span", {
                        className: "tag-text",
                        children: tagText
                    })
                ]
            }))
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "getInputProps", ()=>{
            const { link, isOpenLinkInNewTab } = this.props;
            const inputProps = {};
            // In order to avoid empty href that causes links to root
            if (link) {
                inputProps.href = link;
                inputProps.target = isOpenLinkInNewTab ? "_blank" : "_self";
            }
            return inputProps;
        });
    }
}
export { ButtonImageTag as default };
ButtonImageTag.defaultProps = DefaultProps;
